import React from 'react';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  color?: 'blue' | 'green' | 'purple' | 'orange';
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  size = 'md',
  color = 'blue'
}) => {
  const sizeClasses = {
    sm: 'w-8 h-4',
    md: 'w-11 h-6',
    lg: 'w-14 h-7'
  };

  const thumbSizeClasses = {
    sm: 'after:h-3 after:w-3 after:top-[2px] after:left-[2px]',
    md: 'after:h-5 after:w-5 after:top-[2px] after:left-[2px]',
    lg: 'after:h-6 after:w-6 after:top-[2px] after:left-[2px]'
  };

  const colorClasses = {
    blue: 'peer-checked:bg-blue-600 peer-focus:ring-blue-300',
    green: 'peer-checked:bg-green-600 peer-focus:ring-green-300',
    purple: 'peer-checked:bg-purple-600 peer-focus:ring-purple-300',
    orange: 'peer-checked:bg-orange-600 peer-focus:ring-orange-300'
  };

  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="sr-only peer"
      />
      <div 
        className={`
          ${sizeClasses[size]} 
          bg-gray-200 
          peer-focus:outline-none 
          peer-focus:ring-4 
          ${colorClasses[color]} 
          rounded-full 
          peer 
          peer-checked:after:translate-x-full 
          peer-checked:after:border-white 
          after:content-[''] 
          after:absolute 
          after:bg-white 
          after:border-gray-300 
          after:border 
          after:rounded-full 
          ${thumbSizeClasses[size]} 
          after:transition-all 
          transition-all
          ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        `}
      />
    </label>
  );
};

export default ToggleSwitch;
